import { Alert, Flex } from "antd";
import { IntegratedMetricsLoading, NonIntegratedMetricsLoading } from "./MetricsLoading";
import { getWrapperClassName } from "./paymentsMetricsHelpers";

interface PaymentMetricsPendingProps {
    isError: boolean;
    isPending: boolean;
    isIntegrated: boolean;
    isMarketing: boolean;
}

export const PaymentMetricsPending = ({
    isError,
    isPending,
    isIntegrated,
    isMarketing,
}: PaymentMetricsPendingProps) => (
    <Flex className={getWrapperClassName(isPending, false, isMarketing)} justify="center" gap="middle" vertical>
        {isError && <Alert type="error" showIcon message="Unable to load metrics" />}
        {isPending &&
            (isIntegrated ? <IntegratedMetricsLoading isMarketing={isMarketing} /> : <NonIntegratedMetricsLoading />)}
    </Flex>
);
